<script setup lang="ts">
import { ref, watch } from 'vue'
import SeminarCard from './SeminarCard.vue'

interface SeminarItem {
  id?: number
  [key: string]: unknown
}

const props = defineProps<{
  seminars?: SeminarItem[]
}>()

const slider = ref<{ swiper?: { update: () => void } } | null>(null)

watch(
  () => props.seminars,
  () => {
    slider.value?.swiper?.update()
  },
  { deep: true }
)

const swiperConfig = {
  slidesPerView: 'auto',
  centeredSlides: true,
  centeredSlidesBounds: true,
  spaceBetween: 16,
  watchOverflow: true,

  breakpoints: {
    480: { slidesPerView: 4, centeredSlides: false, slidesPerGroup: 4 }
  },

  pagination: {
    el: '.swiper-pagination'
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
}
</script>

<template>
  <v-slider ref="slider" class="seminar-card-slider" :config="swiperConfig">
    <SeminarCard
      v-for="seminar in seminars"
      v-bind="seminar"
      :key="seminar.id"
      :mode="seminar.id === 0 ? 'large' : ''"
      class="swiper-slide seminar-card-slider__slide"
    ></SeminarCard>
  </v-slider>
</template>

<style lang="scss">
.seminar-card-slider {
  & > .swiper-wrapper {
    padding: 8px 0 32px;
  }

  & > .swiper-pagination {
    bottom: 0px !important;
  }

  & > .swiper-button-disabled {
    pointer-events: initial !important;
  }

  &__slide {
    box-shadow: none;
    min-height: 320px;
    min-width: 200px;

    display: flex !important;

    @include mobile {
      width: calc(100% / 1.25) !important;
      max-width: 240px;
    }
  }
}
</style>
